'use client'
import { useEffect, useState } from 'react'
import BrowserStorage from '@segway/core/src/utils/storage'

import { Link } from '@/i18n/navigation'
import { Button, Drawer, DrawerContent } from '@/ui'

const CookieConsent = () => {
  const [cookieOpen, setCookieOpen] = useState(false)

  const acceptCookies = () => {
    const storage = new BrowserStorage()
    storage.setItemSync('cookie_consent', 'accepted')
    setCookieOpen(false)
  }

  // const denyCookies = () => {
  //   const storage = new BrowserStorage()
  //   storage.setItemSync('cookie_consent', 'denied')
  //   setCookieOpen(false)
  // }

  useEffect(() => {
    const storage = new BrowserStorage()
    const isConsent = storage.getItemSync('cookie_consent')
    if (!isConsent) {
      setCookieOpen(true)
    }
  }, [])

  return (
    <Drawer open={cookieOpen} onOpenChange={setCookieOpen}>
      <DrawerContent>
        <div className="flex flex-col gap-7 p-7 xl:flex-row xl:gap-x-[80px] xl:px-[240px] xl:py-[39px]">
          <div>
            <p className="font-miSansMedium380 text-base text-black">
              This website uses cookies to enhance user experience and to analyze performance and
              traffic on our website. We also share information about your use of
            </p>
            <div className="mt-4 flex xl:mt-0">
              <Link
                href="/"
                className="border-r-2 border-gray-4 pr-1 font-miSansMedium380 text-sm text-black underline xl:text-base">
                Cookie Notice
              </Link>
              <Link
                href="/"
                className="border-r-2 border-gray-4 px-1 font-miSansMedium380 text-sm text-black underline xl:text-base">
                OneTrust
              </Link>
              <Link
                href="/"
                className="border-r-2 border-gray-4 px-1 font-miSansMedium380 text-sm text-black underline xl:text-base">
                CCPA Privacy Policy
              </Link>
              <Link
                href="/"
                className="px-1 font-miSansMedium380 text-sm text-black underline xl:text-base">
                Settings
              </Link>
            </div>
          </div>
          <div className="flex gap-4">
            <Button
              className="flex-1 bg-black px-[38.5px] text-white hover:bg-gray-1 hover:text-black"
              onClick={acceptCookies}>
              Accept All
            </Button>
          </div>
        </div>
      </DrawerContent>
    </Drawer>
  )
}

export default CookieConsent
